module.exports = __webpack_public_path__ + "static/media/disc_3x.d13ab1ea.png";